import React from 'react';
import './KpiPercentiles.css';
import { NO_DATA_FOUND } from '../../../common/contants/constants';
import { infoIcon} from '../../../common/MotifIcons';
import {
  MotifIcon
} from "@ey-xd/motif-react";

export const KpiPercentiles = ({ kpiData }) => {

  const [ titles, setTitles ] = React.useState([]);
  const [ percentiles, setPercentiles ] = React.useState([]);

  const showKPIData = () => {
    let localTitles = [];
    let localPercentiles = [];
    kpiData && kpiData.forEach(element => {
      if (element.title === 'DIO') {
        localTitles[5] = 'Average DIO';
        const updatedArrayOfObjects = element.percentiles.map(obj => {
          return { ...obj, ["title"]: element.title };
        });
        localPercentiles[5] = updatedArrayOfObjects
      }
      else if (element.title === 'DPO') {
        localTitles[4] = 'Average DPO';
        const updatedArrayOfObjects = element.percentiles.map(obj => {
          return { ...obj, ["title"]: element.title };
        });
        localPercentiles[4] = updatedArrayOfObjects
      }
      else if (element.title === 'DSO') {
        localTitles[3] = 'Average DSO';
        const updatedArrayOfObjects = element.percentiles.map(obj => {
          return { ...obj, ["title"]: element.title };
        });
        localPercentiles[3] = updatedArrayOfObjects
      }
      else if (element.title === 'ebitda_margin_perc') {
        localTitles[1] = 'EBITDA Margin';
        const updatedArrayOfObjects = element.percentiles.map(obj => {
          return { ...obj, ["title"]: element.title };
        });
        localPercentiles[1] = updatedArrayOfObjects
      }
      else if (element.title === 'gross_profit_margin') {
        localTitles[0] = 'Gross Margin';
        const updatedArrayOfObjects = element.percentiles.map(obj => {
          return { ...obj, ["title"]: element.title };
        });
        localPercentiles[0] = updatedArrayOfObjects
      }
      else if (element.title === 'NWC') {
        localTitles[2] = 'NWC as a % of Revenue';
        const updatedArrayOfObjects = element.percentiles.map(obj => {
          return { ...obj, ["title"]: element.title };
        });
        localPercentiles[2] = updatedArrayOfObjects
      }
      setTitles(localTitles);
      setPercentiles(localPercentiles);
    });
  }      

  React.useEffect(() => {
    showKPIData();
  }, [kpiData])

  const getValue = (title,average) => {
    if(title === "DSO" || title === "DPO" || title === "DIO"){
     return parseFloat(average).toFixed(2) 
    } else {
      return parseFloat(average).toFixed(2) + '%'
    }
   }

  return (

    <div className='kpi-wrapper'>
      <div className='kpis-header'>
        <div className='kpi-row'>
          <div className='kpi-titles'>KPIs</div>
          <ul className='pki-percentiles'>
            <li> &#60;25 Percentiles </li>
            <li> 25-50 Percentiles </li>
            <li> 50-75 Percentiles </li>
            <li> &#62;75 Percentiles </li>
          </ul>
        </div>
      </div>
      {
        kpiData?.length > 0 || kpiData !== null ?
        <div className='kpis-body'>
        {percentiles ? percentiles.map((item, index) => (
          <div className='kpi-row' key={`kpiKey_${index}`}>
            <div className='kpi-titles'>{titles[index]}</div>
            <ul className='pki-percentiles'>
              {item.map((percentile, index) => (
                <li key={`percentileKey_${index}`}>
                  <div className='percentile-cell full-width'>
                    <span>{percentile.count}</span>
                  </div>
                  <div className='percentile-txt full-width'>
                    <span>{percentile.average ? getValue(percentile.title, percentile.average) : 'No Data'}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )) : <div className='kpi-msg'>{NO_DATA_FOUND}</div>}
      </div> : 'No Data Found'
      }
       <div className='warning-msg'> <MotifIcon src={infoIcon} /><div className='text'> Outputs are generated by AI. AI can generate incorrect predictions. Review of all generated content is strongly advised.</div></div>
    </div>
  );
};
